"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setData_1 = require("./setData");
var defaultValue_1 = require("./defaultValue");
function fixData(schema, data, Vue) {
    var result = 0;
    if (schema.type === 'object') {
        var props = schema.properties;
        for (var key in schema.properties) {
            if (props.hasOwnProperty(key)) {
                var pschema = props[key];
                if (data[key] === undefined) {
                    setData_1.setDataValue(pschema, data, key, defaultValue_1.default(pschema, true), Vue);
                    result++;
                }
                else if (data[key] === null && (pschema.type === 'array' || pschema.type === 'object')) {
                    setData_1.setDataValue(pschema, data, key, defaultValue_1.default(pschema, true), Vue);
                    result++;
                }
                else {
                    result += fixData(pschema, data[key], Vue);
                }
            }
        }
    }
    else if (schema.type === 'array') {
        var pschema = schema.items;
        for (var i = 0; i < data.length; i++) {
            var value = data[i];
            result += fixData(pschema, value, Vue);
        }
    }
    return result;
}
exports.default = fixData;
//# sourceMappingURL=fixData.js.map